import { render, staticRenderFns } from "./scores.vue?vue&type=template&id=2edaa1f2&scoped=true"
import script from "./scores.vue?vue&type=script&lang=js"
export * from "./scores.vue?vue&type=script&lang=js"
import style0 from "./scores.vue?vue&type=style&index=0&id=2edaa1f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edaa1f2",
  null
  
)

export default component.exports